import { z } from 'zod'

export const relativeDateTemplateSchema = z.union([
  z.object({ $monthsAgo: z.number().int().min(0) }).strict(),
  z.object({ $daysAhead: z.number().int() }).strict(),
])

export const filterConditionSchema = z.object({
  field: z.enum([
    'customerType',
    'customerStatus',
    'propertyType',
    'servicePackageId',
    'visitDateFrom',
    'visitDateTo',
    'maintenanceTaskId',
    'opportunityStage',
    'city',
    'userRole',
    'relationshipType',
    'accountManagerUserId',
    'visitDate',
    // Aggregate facet fields — scalar comparisons against MAX/MIN of the
    // customer's nuohous visits. See audienceFacets.ts for the task-id list.
    'lastNuohousDate',
    'nextNuohousDate',
  ]),
  operator: z.enum(['eq', 'in', 'gte', 'lte']),
  value: z.union([
    z.string(),
    z.number(),
    z.array(z.string()),
    z.array(z.number()),
    relativeDateTemplateSchema,
  ]),
})

export const filterGroupSchema = z.object({
  conditions: z.array(filterConditionSchema),
})

export const audienceFilterSchema = z.object({
  include: z.array(filterGroupSchema),
  exclude: z.array(filterGroupSchema),
  includeEmails: z.array(z.string().email()).optional(),
  excludeEmails: z.array(z.string().email()).optional(),
})

export type RelativeDateTemplate = z.infer<typeof relativeDateTemplateSchema>
export type FilterCondition = z.infer<typeof filterConditionSchema>
export type FilterGroup = z.infer<typeof filterGroupSchema>
export type AudienceFilter = z.infer<typeof audienceFilterSchema>
